import { Alert, Box, Grid, Text } from "@chakra-ui/react";
import { useAuth } from "providers/auth.provider";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MenuItemProps, useMenu } from "../../../_config/menu";
import { DesktopMenuItem } from "./DesktopMenuItem";

type Props = {
  search: string;
  onRedirect: () => void;
};

export const DesktopMenuList = ({ search, onRedirect }: Props) => {
  const { info } = useAuth();
  const [menuList, setMenuList] = useState<MenuItemProps[]>([]);
  const { filterMenu } = useMenu(info?.roles ?? []);
  const navigate = useNavigate();

  useEffect(() => {
    const menuFiltered = filterMenu(search);
    setMenuList(menuFiltered);
  }, [search]);

  return (
    <>
      <Box>
        <Text
          fontSize="lg"
          fontWeight="medium"
          maxW="340px"
          mt={2}
          userSelect="none"
          isTruncated
        >
          Menu
        </Text>
      </Box>

      {menuList.length == 0 && (
        <Alert status="info" variant="subtle">
          Nenhum resultado encontrado.
        </Alert>
      )}
      <Grid gap={1} templateColumns="repeat(2, 1fr)">
        {menuList.map((x) => (
          <DesktopMenuItem
            key={x.name + x.to}
            name={x.name}
            description={x.description}
            icon={x.icon}
            hasSubMenu={!!x.subMenu}
            onClick={() => {
              navigate(x.to);
              onRedirect();
            }}
          />
        ))}
      </Grid>
    </>
  );
};
